
import { defineComponent, PropType } from "vue";

import {
  ColumnDefinition,
  OptionType,
  BaseButton,
  DeleteIcon,
  SouthIcon,
  NorthIcon,
  BaseTable,
  FormField,
  FormFieldComboBox,
} from "@tager/admin-ui";
import { Nullable } from "@tager/admin-services";

import { moveItem } from "@/views/BasisProductForm/BasisProductForm.helpers";

const COLUMN_DEFS: Array<ColumnDefinition> = [
  {
    id: 1,
    name: "Название",
    field: "name",
    style: { width: "50%" },
    headStyle: { width: "50%" },
  },
  {
    id: 2,
    name: "Категория",
    field: "category",
    style: { width: "50%" },
    headStyle: { width: "50%" },
  },
  {
    id: 3,
    name: "",
    field: "actions",
    style: { width: "140px", textAlign: "center", whiteSpace: "nowrap" },
    headStyle: { width: "140px", textAlign: "center" },
  },
];

type Props = Readonly<{
  categories: Array<{
    name: string;
    category: OptionType<number>;
  }>;
}>;

export default defineComponent({
  name: "CategoryTable",
  components: {
    BaseButton,
    DeleteIcon,
    SouthIcon,
    NorthIcon,
    BaseTable,
    FormField,
    FormFieldComboBox,
  },
  props: {
    categories: {
      type: Array as PropType<Props["categories"]>,
      required: true,
    },
    categoryOptionList: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    function removeField(rowIndex: number) {
      props.categories.splice(rowIndex, 1);
    }

    function handleClick(
      itemList: Array<{
        name: string;
        category: Nullable<OptionType<number>>;
      }>,
      itemIndex: number,
      direction: "up" | "down"
    ) {
      moveItem<{
        name: string;
        category: Nullable<OptionType<number>>;
      }>(itemList, itemIndex, direction);
    }

    function addElement(
      categories: Array<{
        name: string;
        category: Nullable<OptionType<number>>;
      }>
    ) {
      categories.push({
        name: "",
        category: null,
      });
    }

    return {
      columnDefs: COLUMN_DEFS,
      removeField,
      handleClick,
      addElement,
    };
  },
});
